export default __webpack_public_path__ + "static/media/harrison-healthcare.png";